// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 100%;
  margin-bottom: 5px;
  --inner-padding-start: 10px;
  border-radius: var(--radius-default);
}

.checkbox-price {
  color: #b5b5b5;
}

.hidden {
  visibility: hidden;
}

.price {
  margin-right: 10px;
  color: var(--ion-color-black);
  font-weight: 400;
}

.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translate(-3%, -57%);
  height: 15px;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--ion-color-primary);
}

ion-checkbox {
  margin: 0 12px 0 0;
  --background: transparent;
  --background-checked: #1ea45a;
  --border-color: rgba(30, 164, 90, 0.45);
  --border-color-checked: #1ea45a;
  --border-width: 1px;
  --checkmark-color: #0f2a18;
  --checkmark-width: 3px;
  --border-radius: 3px;
  --size: 20px;
}

ion-checkbox::part(container) {
  background: transparent;
}

ion-checkbox.checkbox-checked::part(container) {
  background: #1ea45a;
  border-color: #1ea45a;
}

ion-checkbox.checkbox-checked::part(mark) {
  color: #0f2a18;
}

app-tag {
  display: inline-block;
  margin-left: 5px;
}

ion-item {
  background: #ffffff;
  border: 0.5px solid #e2dcd5;
}

ion-label {
  font-size: 12px !important;
  font-family: AppFont, sans-serif;
  margin-right: 3px;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACG,2BAAA;EACA,oCAAA;AACJ;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,6BAAA;EACA,gBAAA;AACD;;AAGC;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACC,4BAAA;AAAH;AAGE;EACC,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,YAAA;AADH;AAKC;EACC,aAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AAHF;;AAOA;EACC,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,uCAAA;EACA,+BAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;AAJD;;AAOA;EACC,uBAAA;AAJD;;AAOA;EACC,mBAAA;EACA,qBAAA;AAJD;;AAOA;EACC,cAAA;AAJD;;AAOA;EACC,qBAAA;EACC,gBAAA;AAJF;;AAMA;EACC,mBAAA;EACA,2BAAA;AAHD;;AAKA;EACC,0BAAA;EACA,gCAAA;EACC,iBAAA;AAFF;;AAKA;EACC,eAAA;AAFD","sourcesContent":["ion-item {\n\twidth: 100%;\n\tmargin-bottom: 5px;\n    --inner-padding-start: 10px;\n    border-radius: var(--radius-default);\n}\n\n.checkbox-price {\n\tcolor: #b5b5b5;\n}\n\n.hidden {\n\tvisibility: hidden;\n}\n\n.price {\n\tmargin-right: 10px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n}\n\n.qty {\n\t&__btn {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin: 0 !important;\n\t\tbox-shadow: none;\n\t\t--box-shadow: none;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tbutton {\n\t\t\tbox-shadow: unset !important;\n\t\t}\n\n\t\tspan {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translate(-3%, -57%);\n\t\t\theight: 15px;\n\t\t}\n\t}\n\n\t.qty-number {\n\t\tmargin: 0 4px;\n\t\ttext-align: center;\n\t\tmin-width: 15px;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\nion-checkbox {\n\tmargin: 0 12px 0 0;\n\t--background: transparent;\n\t--background-checked: #1ea45a;\n\t--border-color: rgba(30, 164, 90, 0.45);\n\t--border-color-checked: #1ea45a;\n\t--border-width: 1px;\n\t--checkmark-color: #0f2a18;\n\t--checkmark-width: 3px;\n\t--border-radius: 3px;\n\t--size: 20px;\n}\n\nion-checkbox::part(container) {\n\tbackground: transparent;\n}\n\nion-checkbox.checkbox-checked::part(container) {\n\tbackground: #1ea45a;\n\tborder-color: #1ea45a;\n}\n\nion-checkbox.checkbox-checked::part(mark) {\n\tcolor: #0f2a18;\n}\n\napp-tag {\n\tdisplay: inline-block;\n  margin-left: 5px;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder: 0.5px solid #e2dcd5;\n}\nion-label {\n\tfont-size: 12px !important;\n\tfont-family: AppFont, sans-serif;\n  margin-right: 3px;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
